<template>
  <div ref="targetElement">
    <slot />
  </div>
</template>

<script setup>
import { useMainStore } from '@/store'

const FOOTER_TAB_HEIGHT = 70
const PC_HEADER_HEIGHT = 103
const SP_HEADER_HEIGHT = 85
const targetElement = ref(null)
const store = useMainStore()
const emit = defineEmits(['elementInView', 'elementNotInView'])
const props = defineProps({
  observeViewHeight: { type: Number, default: 200, required: false }, // The height of observer viewport view you want system to watch, by default it will be 200px
  observeFromBottom: { type: Boolean, default: false, required: false }
})

onMounted(() => {
  const offsetTop = store.isSP ? SP_HEADER_HEIGHT : PC_HEADER_HEIGHT

  const checkElementInView = () => {
    const rect = targetElement.value?.getBoundingClientRect()
    if (!rect) return

    const viewportHeight = window.innerHeight || document.documentElement.clientHeight
    const viewBottom = props.observeFromBottom ? viewportHeight - props.observeViewHeight : viewportHeight - offsetTop - props.observeViewHeight

    const isInView = rect.top <= viewBottom && rect.bottom >= offsetTop
    if (isInView) {
      emit('elementInView')
    } else {
      emit('elementNotInView')
    }
  }

  window.addEventListener('scroll', checkElementInView)
})
</script>
